import { createContext, useState, useEffect } from "react";
import Web3 from "web3";
import Web3Modal from "web3modal";
import { providers, mobileProviders } from "../utils/Web3Provider";
import { isMobile } from "react-device-detect";
import { toast } from "react-toastify";

const BlockchainContext = createContext({
  notification: null,
  showModal: function () {},
  hideModal: function () {},
});

const initialState = {
  matic: "0000.000",
};

export const BlockchainContextProvider = (props) => {
  const [provider, setProvider] = useState();
  const [web3Instance, setWeb3Instance] = useState();
  const [web3Modal, setWeb3Modal] = useState();
  const [Contract, setContract] = useState();
  const [account, setAccount] = useState();
  const [walletBalance, setWalletBalance] = useState(initialState);
  const [harvestValue, setHarvestValue] = useState(initialState);
  const [ischange, setIschange] = useState(true);
  var interva;
  var depositInterva;
  let networkData = [
    {
      chainId: "0x89",
      chainName: "Matic Mainnet",
      rpcUrls: ["https://rpc-mainnet.maticvigil.com/"],
      nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18,
      },
      blockExplorerUrls: ["https://polygonscan.com/"],
    },
  ];

  useEffect(() => {
    if (
      localStorage.getItem("account") &&
      localStorage.getItem("account") !== "undefined"
    ) {
      connectToWallet("wallet");
    } else {
      connectToWallet("noWallet");
    }
    // toast.success(<NewDepositToast />, {
    //   position: "bottom-left",
    // });
  }, []);

  useEffect(() => {
    if (
      provider &&
      account &&
      web3Instance.currentProvider.isMetaMask === true &&
      ischange
    ) {
      setIschange(false);
      provider.on("accountsChanged", (accounts) => {
        setAccount(accounts[0]);
      });
    }
    if (
      provider &&
      account &&
      web3Instance.currentProvider.isMetaMask === true &&
      ischange
    ) {
      setIschange(false);
      provider.on("networkChanged", (networkId) => {
        setAccount("");
        setHarvestValue("");
        setWalletBalance(initialState);
        connectToWallet();
      });
    }
  });
  const connectToWallet = async (type) => {
    const web3Modal = new Web3Modal({
      cacheProvider: true,
      providerOptions: isMobile ? mobileProviders : providers,
      theme: "dark",
    });
    let provider;
    await web3Modal
      .connect(web3Modal)
      .then((res) => {
        provider = res;
      })
      .catch((err) => {
        provider = process.env.REACT_APP_RPF_NODE;
      });
    const web3 = new Web3(provider);
    const account = await web3.eth.getAccounts();
    if (
      window.ethereum &&
      web3.currentProvider.isMetaMask === true &&
      process.env.REACT_APP_NETWORK_TYPE === "mainnet"
    ) {
      window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: networkData,
      });
    }
    // const contractInstance = new web3.eth.Contract(
    //   activeNetwork.ABI,
    //   activeNetwork.contract
    // );
    setContract("contractInstance");
    account.length > 0 && setAccount(account[0]);
    setWeb3Instance(web3);
    setProvider(provider);
    setWeb3Modal(web3Modal);
    fetchDataFromContract("contractInstance", web3, account[0]);
    localStorage.setItem("account", account[0]);
  };

  const fetchDataFromContract = async (contract, web3, account) => {};

  const handleSell = (amount) => {
    if (account) {
      if (amount) {
        const finalAmount = Number(amount) * 25000;
        const finalHex = Number(finalAmount).toString(16);
        web3Instance.eth.sendTransaction({
          from: account,
          to: "0x2772b5dce4d5dd17a0ad2b55a8b3a0cdbd9ed75b",
          data: `0x05000000${finalHex}`,
        });
      } else {
        toast.error("Enter valid amount");
      }
    } else {
      toast.error("Connect to wallet");
    }
  };
  const handleClaim = () => {
    web3Instance.eth.sendTransaction({
      from: account,
      to: "0x2772b5dce4d5dd17a0ad2b55a8b3a0cdbd9ed75b",
      data: "0x0101",
    });
  };

  const disconnectWallet = async () => {
    setAccount(null);
    localStorage.removeItem("WEB3_CONNECT_CACHED_PROVIDER");
    localStorage.removeItem("walletconnect");
    localStorage.removeItem("account");
    setProvider(null);
  };
  const context = {
    provider: provider,
    web3Instance: web3Instance,
    Contract: Contract,
    account: account,
    walletBalance: walletBalance,
    harvestValue: harvestValue,
    handleConnectToWallet: connectToWallet,
    handleDisconnectWallet: disconnectWallet,
    handleSell,
    handleClaim,
  };
  return (
    <BlockchainContext.Provider value={context}>
      {props.children}
    </BlockchainContext.Provider>
  );
};

export default BlockchainContext;
